import { RouteConfig } from 'vue-router';
import store, { smartRootModule } from './baseStore';

const context = smartRootModule.context(store);

export const enum Paths {
    WHATS_NEW = 'whats-new',
}

export const enum Names {
    WHATS_NEW = 'whats-new',
}

const routes: RouteConfig[] = [
    {
        path: Paths.WHATS_NEW,
        name: Names.WHATS_NEW,
        beforeEnter: (_to, _from, next) => {
            context.modules.whatsnew.mutations.showModal();
            next(false);
        },
    },
];

export default routes;
